<template>
    <div class="wl-new-center">
        <div class="new-center-content">
            <div class="new-center-top fl">
                <div class="new-top-nav" :style="{ background: 'url(' + imgs + ')' }">
                    <h1 class="new-top-title fl">N</h1>
                    <div class="fl" style="padding-left:4px;">
                        <p class="new-top-navtitle">新闻中心</p>
                        <p class="new-top-ews">EWS</p>
                    </div>
                </div>
                <div class="new-center-tab">
                    <!-- :class="{'class-back':isTab == 1}" -->
                    <div class="new-center-dynamic" :class="{'class-back':isTab == 1}" @click="tabSwitch(1)">
                        新闻动态
                        <span class="wl-icon wl-icon-xiangyou fr"></span>
                    </div>
                    <div class="new-center-dynamic" :class="{'class-back':isTab == 2}" @click="tabSwitch(2)">
                        通知公告
                        <span class="wl-icon wl-icon-xiangyou fr"></span>
                    </div>
                </div>
            </div>
            <div class="new-center-listnav">
                <h2 v-show="isTab == 1">新闻动态</h2>
                <h2 v-show="isTab == 2">通知公告</h2>
                <div class="new-center-path">
                    <div class="crumbs-text">
                        <i class="wl-icon-zhuye1"></i>
                        <span>当前位置：</span>
                        <span @click="goHome" style="cursor: pointer;">网站首页</span>
                        <span>></span>
                        <span v-show="isTab == 1">新闻中心</span>
                        <span v-show="isTab == 2">通知公告</span>
                    </div>
                </div>
            </div>
            <div class="new-center-list clearfix" v-for="(item, index) in newsList" :key="index">
                <div class="new-center-li" @click="goNewsDetail(item.id)">
                    <div class="li-back-date">
                        <p class="date-class">{{ item.date }}</p>
                        <p>{{ item.month }}</p>
                    </div>
                    <div class="new-center-left">
                        <p class="text-title">{{ item.title }}</p>
                        <p class="text-detail" v-html="item.contentText"></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="el-block-pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4" :page-sizes="[10, 20, 40, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
        </div>

        <!-- 手机端 -->
        <div class="ph-new-center-content">
            <div class="crumbs-text">
                <div style="padding:0 20px;">
                    <i class="wl-icon-zhuye1"></i>
                    <span @click="goHome" style="cursor: pointer;">首页</span>
                    <span>></span>
                    <span v-show="isTab == 1">新闻动态</span>
                    <span v-show="isTab == 2">通知公告</span>
                </div>
            </div>

            <div class="new-center-navigation clearfix">
                <h2 :class="isTab == 1 ? 'activa' : ''" @click="tabSwitch(1)">新闻动态</h2>
                <h2 :class="isTab == 2 ? 'activa' : ''" @click="tabSwitch(2)">通知公告</h2>
            </div>
            <v-refresh :on-refresh="onRefresh">
                <v-reload :on-infinite-load="onInfiniteLoad" :parent-pull-up-state="infiniteLoadData.pullUpState">
                    <div class="new-center-list clearfix" v-for="(item, index) in phDetailsData" :key="index">
                        <div class="new-center-li" @click="goNewsDetail(item.id)">
                            <div class="li-back-date">
                                <p class="date-class">{{ item.date }}</p>
                                <p>{{ item.month }}</p>
                            </div>
                            <div class="new-center-left">
                                <p class="text-title">{{ item.title }}</p>
                                <p class="text-detail" v-html="item.contentText"></p>
                            </div>
                        </div>
                    </div>
                </v-reload>
            </v-refresh>
        </div>
    </div>
</template>

<script>
import downFresh from "components/refreshData/downFresh.vue";
import pullUpReload from "components/refreshData/pullUpReload.vue";
export default {
    data() {
        return {
            imgs: require("assets/images/bg-news.png"),
            isTab: 1,
            pageSize: 10,
            type: 1,
            totalCount: 0,
            currentPage4: 1,
            newsList: [],
            phDetailsData: [],
            infiniteLoadData: {
                initialShowNum: 3, // 初始显示多少条
                everyLoadingNum: 3, // 每次加载的个数
                pullUpState: 0, // 子组件的pullUpState状态
                pullUpList: [], // 上拉加载更多数据的数组
                showPullUpListLength: this.initialShowNum, // 上拉加载后所展示的个数
            },
        };
    },
    components: {
        "v-refresh": downFresh,
        "v-reload": pullUpReload,
    },
    created() {
        if (this.$route.params.isTab == undefined) {
            this.isTab = 1;
            this.type = 1;
        } else {
            this.isTab = this.$route.params.isTab;
            this.type = this.$route.params.isTab;
        }
        this.getNewsr();
    },
    computed: {
        association: function() {
            return this.$store.state.association;
        },
    },
    methods: {
        onRefresh(done) {
            this.phDetailsData = [];
            this.getNewsr();
            done();
        },
        onInfiniteLoad(done) {
            this.getNewsr();
            done();
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.getNewsr(1);
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.getNewsr(val);
        },
        tabSwitch(type) {
            this.type = type;
            this.pageSize = 10;
            this.newsList = [];
            this.getNewsr(1);
            this.isTab = type;
        },
        goNewsDetail(newsId) {
            this.$router.push({
                name: "newsDetail",
                params: {
                    newsId: newsId,
                    isTab: this.type,
                },
            });
        },
        goHome() {
            this.$router.push({
                name: "xHome",
            });
        },
        getNewsr(page) {
            var that = this;
            this.$http
                .post("/api/XOrg/AssociationIndex/getNewsr", {
                    type: this.type,
                    associationId: this.association.Id,
                    pageSize: this.pageSize,
                    page,
                })
                .then(function(rst) {
                    that.newsList = rst.list;
                    that.phDetailsData = rst.list;
                    that.pageSize = rst.pagination.pageSize;
                    that.totalCount = rst.pagination.totalCount;
                    console.log(that.infiniteLoadData.pullUpState);
                    if (that.phDetailsData.length == that.totalCount) {
                        that.infiniteLoadData.pullUpState = 3;
                    }
                });
        },
    },
};
</script>

<style></style>
